import {useEffect, useState} from 'react';

export function useRandomRotation<T>(
    items: T[],
    intervalMs = 7000,
    preventRepeat = true
): {
    currentIndex: number;
    currentItem: T;
} {
    const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * items.length));
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                if (!preventRepeat || items.length <= 1) {
                    return Math.floor(Math.random() * items.length);
                }
                let newIndex;
                do {
                    newIndex = Math.floor(Math.random() * items.length);
                } while (newIndex === prevIndex);
                return newIndex;
            });
        }, intervalMs);
        return () => clearInterval(interval);
    }, [items.length, intervalMs, preventRepeat]);
    return {currentIndex, currentItem: items[currentIndex]};
}
